import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-burial-details-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-burial-details-cm.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateBurialDetailsCmConstants } from "./create-burial-details-cm.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { DatePipe } from "@angular/common";
import { ViewDeceasedDetailsCmConstant } from "../../../../view-application/modules/cm/view-deceased-details-cm/view-deceased-details-cm.constants";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { forkJoin } from "rxjs";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { take } from "rxjs/operators";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { CemeteryStrategyService } from "../../../../shared/services/afla-module-strategy/cemetery-strategy.service";
import { MapService } from "../../../../map/shared/map.service";
import { MapServiceService } from "../../../../map/shared/map-service.service";
import { AppConfig } from "../../../../app.config";
import { AlertType } from "../../../../shared/models/alert";
let CreateBurialDetailsCmComponent = class CreateBurialDetailsCmComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    cemeteryStrategyService;
    appController;
    requestStatusService;
    mapService;
    mapServiceService;
    changeDetectorRefs;
    datePipe;
    searchApplicationsService;
    detailsFormGroupName = CreateBurialDetailsCmConstants.DETAILS_FORM_GROUP_NAME;
    burialTypeControl = CreateBurialDetailsCmConstants.BURIAL_TYPE_CONTROL;
    cemeteryControl = CreateBurialDetailsCmConstants.CEMETERY_CONTROL;
    cemeteryLabel = CreateBurialDetailsCmConstants.CEMETERY_LABEL;
    burialTypeLabel = CreateBurialDetailsCmConstants.BURIAL_TYPE_LABEL;
    burialDateControl = CreateBurialDetailsCmConstants.BURIAL_DATE_CONTROL;
    burialDateLabel = CreateBurialDetailsCmConstants.BURIAL_DATE_LABEL;
    burialTypePlaceHolder = CreateBurialDetailsCmConstants.BURIAL_TYPE_PH;
    validationMessages = CreateBurialDetailsCmConstants.VALIDATION_MESSAGES;
    burialDescriptionControl = CreateBurialDetailsCmConstants.DESCRIPTION_CONTROL;
    burialDescriptionLabel = CreateBurialDetailsCmConstants.DESCRIPTION_LABEL;
    cemeteryPlaceHolder = SharedConstants.CEMETERY_PLACEHOLDER_TEXT;
    dropdownPlaceHolder = SharedConstants.PLACEHOLDER_TEXT;
    title = CreateBurialDetailsCmConstants.STEP_TITLE;
    burialTypes = [];
    cemeteries = [];
    defaultGraveStatus = [];
    defaultCemetery = {
        cemeteryObjectId: null,
        cemeteryName: CreateBurialDetailsCmConstants.DEFAULT_CEMETERY_NAME,
        cemeteryId: null
    };
    detailsForm;
    selectedApplicationCmSubscription;
    getLookupsObservableSubscripiton;
    cemeteriesSubscription;
    checkMapLayersSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, cemeteryStrategyService, appController, requestStatusService, mapService, mapServiceService, changeDetectorRefs, datePipe, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.cemeteryStrategyService = cemeteryStrategyService;
        this.appController = appController;
        this.requestStatusService = requestStatusService;
        this.mapService = mapService;
        this.mapServiceService = mapServiceService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.datePipe = datePipe;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.loadLookup();
        this.getMetadata();
        this.populateForm(this.selectedApplication);
        this.subscribeToSelectedApplication();
        this.subscribeToCheckFormValidity();
    }
    loadMetadata(stepMeta) {
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationCmSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("burialForm");
        this.detailsForm.enable();
    }
    populateForm(application) {
        if (application && application.appId > 0)
            this.detailsForm.markAsTouched();
        else
            return;
        this.detailsForm.get(this.cemeteryControl).setValue(application.cemeteryId);
        this.detailsForm.get(this.burialTypeControl).setValue(application.type);
        this.detailsForm.get(this.burialDescriptionControl).setValue(application.description);
        if (application.burialDate !== undefined && application.burialDate !== null) {
            const dateString = this.datePipe.transform(application.burialDate, ViewDeceasedDetailsCmConstant.DATE_CONST);
            this.detailsForm.get(this.burialDateControl).setValue(dateString);
        }
    }
    loadLookup() {
        this.getLookupsObservableSubscripiton = this.applicationCreateService.getLookupsObservable({ $filter: `moduleId eq ${this.appController.selectedModuleID} and (name eq 'ApplicationType' or name eq 'DefaultGraveStatus') and deleted eq false` }).subscribe(response => {
            const applicationTypes = [];
            const defaultGraveStatus = [];
            if (response && response.value.length > 0) {
                response.value.forEach(item => {
                    if (item.name === "ApplicationType") {
                        applicationTypes.push(JSON.parse(item.content));
                    }
                    if (item.name === "DefaultGraveStatus") {
                        defaultGraveStatus.push(JSON.parse(item.content));
                    }
                });
            }
            applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
            defaultGraveStatus.sort((a, b) => a.value.localeCompare(b.value));
            this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
            this.aflaModuleStrategyService.lookups.set("defaultGraveStatus", defaultGraveStatus);
            this.burialTypes = applicationTypes;
            this.defaultGraveStatus = defaultGraveStatus;
            this.getCemeteries();
        });
    }
    getCemeteries() {
        this.requestStatusService.showBusySpinner("Getting maps...");
        this.applicationCreateService.getCemeterySelectionModuleMaps(+this.appController.selectedModuleID).pipe(take(1)).subscribe({
            next: (moduleMapsResult) => {
                const moduleMaps = moduleMapsResult.value;
                let cemeteryModuleMap = null;
                let graveModuleMap = null;
                for (const moduleMap of moduleMaps) {
                    if (moduleMap.selectionLayerType === "Cemetery") {
                        cemeteryModuleMap = moduleMap;
                    }
                    if (moduleMap.selectionLayerType === "Grave") {
                        graveModuleMap = moduleMap;
                    }
                }
                if (cemeteryModuleMap !== null && graveModuleMap !== null) {
                    const gravesIds = this.defaultGraveStatus.map(item => `GraveStatus='${item.value}'`);
                    const gravesQueryWhere = gravesIds.join(" or ");
                    const gravesQueryReturnGeometry = false;
                    const gravesQueryOutFields = "CemeteryID";
                    const gravesQueryReturnDistinctValues = true;
                    const cemeteryQueryWhere = `1=1`;
                    const cemeteryQueryReturnGeometry = false;
                    const cemeteryQueryOutFields = "*";
                    const proxyUrl = ApiProxyConstants.URL;
                    let graveQueryUrl = "";
                    if (graveModuleMap.url.endsWith("/")) {
                        graveQueryUrl = "query";
                    }
                    else {
                        graveQueryUrl = "/query";
                    }
                    const graveUrl = `${graveModuleMap.url}${graveQueryUrl}?where=${gravesQueryWhere}&returnGeometry=${gravesQueryReturnGeometry}&outFields=${gravesQueryOutFields}&returnDistinctValues=${gravesQueryReturnDistinctValues}&f=json`;
                    let cemeteryQueryUrl = "";
                    if (cemeteryModuleMap.url.endsWith("/")) {
                        cemeteryQueryUrl = "query";
                    }
                    else {
                        cemeteryQueryUrl = "/query";
                    }
                    const cemeteryUrl = `${cemeteryModuleMap.url}${cemeteryQueryUrl}?where=${cemeteryQueryWhere}&returnGeometry=${cemeteryQueryReturnGeometry}&outFields=${cemeteryQueryOutFields}&f=json`;
                    const proxyGavesUrl = `${proxyUrl}?${encodeURIComponent(graveUrl)}`;
                    const proxyCemeteryUrl = `${proxyUrl}?${encodeURIComponent(cemeteryUrl)}`;
                    forkJoin([this.applicationCreateService.queryMapViaProxy(proxyCemeteryUrl, cemeteryModuleMap.id),
                        this.applicationCreateService.queryMapViaProxy(proxyGavesUrl, graveModuleMap.id)])
                        .pipe(take(1))
                        .subscribe({
                        next: data => {
                            const cemeteryFeatureSet = data[0];
                            const gravesFeatureSet = data[1];
                            if (gravesFeatureSet?.features?.length > 0) {
                                const gravesIds = gravesFeatureSet.features.map(item => this.propertyDataAlternateColumnName(item.attributes, "CemeteryID", "cemeteryid"));
                                if (cemeteryFeatureSet?.features?.length > 0) {
                                    const filteredCemeteries = cemeteryFeatureSet.features
                                        .map(item => ({
                                        cemeteryName: this.propertyDataAlternateColumnName(item.attributes, "Name", "name"),
                                        cemeteryId: this.propertyDataAlternateColumnName(item.attributes, "OBJECTID", "objectid"),
                                        cemeteryObjectId: null
                                    }))
                                        .filter(cemetery => gravesIds.includes(cemetery.cemeteryId));
                                    this.cemeteries = [
                                        this.defaultCemetery,
                                        ...filteredCemeteries
                                    ];
                                    this.cemeteries = [
                                        this.cemeteries[0],
                                        ...this.cemeteries.slice(1).sort((a, b) => a?.cemeteryName?.localeCompare(b?.cemeteryName))
                                    ];
                                    this.aflaModuleStrategyService.lookups.set("cemeteries", this.cemeteries);
                                    this.detailsForm.get(this.cemeteryControl).setValue(this.defaultCemetery);
                                    this.changeDetectorRefs.detectChanges();
                                }
                            }
                            this.requestStatusService.removeBusySpinner("Getting cemeteries");
                        },
                        error: error => {
                            this.requestStatusService.removeBusySpinner("Getting cemeteries");
                            this.appController.handleServerErrorMessage(CreateBurialDetailsCmConstants.STEP_TITLE, error, CRUDOperation.Get);
                        }
                    });
                }
                else {
                    this.requestStatusService.removeBusySpinner("Getting cemeteries");
                }
            },
            error: (error) => {
                this.requestStatusService.removeBusySpinner("Getting cemeteries");
                this.appController.handleServerErrorMessage(CreateBurialDetailsCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    getLayer(maps, layerName) {
        let result = null;
        for (const map of maps) {
            if (map.moduleId === Number(this.appController.selectedModuleID) && (map.selectionLayerType === layerName)) {
                const elUrl = map.url;
                const elTitle = map.selectionLayerType;
                //create layer
                let layer = null;
                layer = new FeatureLayer({
                    url: elUrl,
                    title: elTitle,
                    visible: false
                });
                result = layer;
                break;
            }
        }
        return result;
    }
    checkBurialDate() {
        const selectedDate = new Date(this.detailsForm.get(this.burialDateControl).value);
        const numberOfDays = AppConfig.settings.burialDateWarning.numberOfDays;
        const warningDate = this.getBusinessDates(new Date(), numberOfDays);
        if (selectedDate <= warningDate && numberOfDays > 0) {
            this.detailsForm.get(this.burialDateControl).setErrors({ invalid: true });
            this.appController.showMessage(`Application will not be processed within ${numberOfDays} day(s) before burial`, AlertType.Warning);
        }
        else {
            this.detailsForm.get(this.burialDateControl).setErrors(null);
        }
    }
    getBusinessDates(currentDate, numberOfDays) {
        let count = 0;
        while (count < numberOfDays) {
            const dayOfWeek = currentDate.getDay();
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                count++;
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return currentDate;
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.detailsForm && formGroupName === this.detailsFormGroupName) {
                    this.detailsForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: CemeteryStrategyService },
        { type: AppControllerService },
        { type: RequestStatusService },
        { type: MapService },
        { type: MapServiceService },
        { type: ChangeDetectorRef },
        { type: DatePipe },
        { type: SearchApplicationsService }
    ];
};
CreateBurialDetailsCmComponent = __decorate([
    Component({
        selector: "app-create-burial-details-cm",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateBurialDetailsCmComponent);
export { CreateBurialDetailsCmComponent };
